import IosAddToHomeScreen from './IosAddToHomeScreen'

const InstallService=()=>{
    return <IosAddToHomeScreen/>
}

export default InstallService